import type { L10n, Track } from '@aera/schema';

/**
 * The welcome screen's two cards, kept apart from the question banks so the browser can show them
 * without bundling either bank (the questionnaire itself comes from the API).
 */
export const TRACK_INFO: Record<Track, { name: L10n; pitch: L10n; welcomeTitle: L10n }> = {
  consulting: {
    name: { zh: '企业 AI 转型', en: 'AI transformation' },
    welcomeTitle: { zh: '先了解贵司业务，再探讨 AI 方案', en: 'Tell us about the work first. AI comes after.' },
    pitch: {
      zh: '运用 AI 优化内部流程、报表、客户服务与协作',
      en: 'Use AI on internal work: processes, reports, service and coordination',
    },
  },
  overseas: {
    name: { zh: '出海增长', en: 'Overseas growth' },
    welcomeTitle: { zh: '先了解贵司业务，再探讨出海方案', en: 'Tell us about the business first. Markets come after.' },
    pitch: {
      zh: '寻找海外买家：市场选择、多语言官网、开发信与社交媒体运营',
      en: 'Find overseas buyers: pick markets, build a multilingual site, run outreach and social',
    },
  },
};

/** Shown when an invite was created without a track. */
export const TRACK_PICKER_PROMPT: L10n = { zh: '请选择您希望咨询的方向：', en: 'What would you like to talk about?' };
